// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file bgauth/bgauth.proto (package lvdr.v2.bgauth, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bgauth/bgauth.proto.
 */
export const file_bgauth_bgauth: GenFile = /*@__PURE__*/
  fileDesc("ChNiZ2F1dGgvYmdhdXRoLnByb3RvEg5sdmRyLnYyLmJnYXV0aCJDChpBdXRob3JpemVCYWNrZ3JvdW5kUmVxdWVzdBITCgt3b3JrZmxvd19pZBgBIAEoCRIQCghiZ190b2tlbhgCIAEoDCIuChdSZXZva2VCYWNrZ3JvdW5kUmVxdWVzdBITCgt3b3JrZmxvd19pZBgBIAEoCSIuChtTZXRCYWNrZ3JvdW5kQWNjb3VudFJlcXVlc3QSDwoHYWxsb3dlZBgBIAEoCCIbChlMaXN0QmFja2dyb3VuZEF1dGhSZXF1ZXN0IlEKEkJhY2tncm91bmRBdXRoSXRlbRITCgt3b3JrZmxvd19pZBgBIAEoCRIVCg1hdXRob3JpemVkX2F0GAIgASgJEg8KB2V4cGlyZWQYAyABKAgiZAoWQmFja2dyb3VuZEF1dGhSZXNwb25zZRIXCg9hY2NvdW50X2FsbG93ZWQYASABKAgSMQoFaXRlbXMYAiADKAsyIi5sdmRyLnYyLmJnYXV0aC5CYWNrZ3JvdW5kQXV0aEl0ZW1CJ1olZ2l0aHViLmNvbS9ndnM0Mi9sdmRyL3Byb3RvL3YyL2JnYXV0aGIGcHJvdG8z");

/**
 * AuthorizeBackgroundRequest arms gate 2 for one workflow. The client generates
 * the bgToken device-side, stores it wrapped to the device key, and sends it raw
 * exactly once over the authenticated, unlocked WS. The server seals the
 * live-session DEK under it (crypto.SealBackgroundDEK), persists only the sealed
 * blob + sha256(bgToken), and discards the raw token — so the server can never
 * unseal offline (no escrow). Server-side sealing reuses the audited crypto core
 * instead of reimplementing it in the browser (decision: design §12/S7).
 *
 * @generated from message lvdr.v2.bgauth.AuthorizeBackgroundRequest
 */
export type AuthorizeBackgroundRequest = Message<"lvdr.v2.bgauth.AuthorizeBackgroundRequest"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * raw 32-byte device token; hashed + used to seal server-side, never persisted
   *
   * @generated from field: bytes bg_token = 2;
   */
  bgToken: Uint8Array;
};

/**
 * Describes the message lvdr.v2.bgauth.AuthorizeBackgroundRequest.
 * Use `create(AuthorizeBackgroundRequestSchema)` to create a new message.
 */
export const AuthorizeBackgroundRequestSchema: GenMessage<AuthorizeBackgroundRequest> = /*@__PURE__*/
  messageDesc(file_bgauth_bgauth, 0);

/**
 * RevokeBackgroundRequest deletes one workflow's authorization. An empty
 * workflow_id revokes ALL of the user's authorizations.
 *
 * @generated from message lvdr.v2.bgauth.RevokeBackgroundRequest
 */
export type RevokeBackgroundRequest = Message<"lvdr.v2.bgauth.RevokeBackgroundRequest"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;
};

/**
 * Describes the message lvdr.v2.bgauth.RevokeBackgroundRequest.
 * Use `create(RevokeBackgroundRequestSchema)` to create a new message.
 */
export const RevokeBackgroundRequestSchema: GenMessage<RevokeBackgroundRequest> = /*@__PURE__*/
  messageDesc(file_bgauth_bgauth, 1);

/**
 * SetBackgroundAccountRequest flips gate 1 — the account master switch. Off is
 * the kill switch: every blob stops being honored at once.
 *
 * @generated from message lvdr.v2.bgauth.SetBackgroundAccountRequest
 */
export type SetBackgroundAccountRequest = Message<"lvdr.v2.bgauth.SetBackgroundAccountRequest"> & {
  /**
   * @generated from field: bool allowed = 1;
   */
  allowed: boolean;
};

/**
 * Describes the message lvdr.v2.bgauth.SetBackgroundAccountRequest.
 * Use `create(SetBackgroundAccountRequestSchema)` to create a new message.
 */
export const SetBackgroundAccountRequestSchema: GenMessage<SetBackgroundAccountRequest> = /*@__PURE__*/
  messageDesc(file_bgauth_bgauth, 2);

/**
 * @generated from message lvdr.v2.bgauth.ListBackgroundAuthRequest
 */
export type ListBackgroundAuthRequest = Message<"lvdr.v2.bgauth.ListBackgroundAuthRequest"> & {
};

/**
 * Describes the message lvdr.v2.bgauth.ListBackgroundAuthRequest.
 * Use `create(ListBackgroundAuthRequestSchema)` to create a new message.
 */
export const ListBackgroundAuthRequestSchema: GenMessage<ListBackgroundAuthRequest> = /*@__PURE__*/
  messageDesc(file_bgauth_bgauth, 3);

/**
 * @generated from message lvdr.v2.bgauth.BackgroundAuthItem
 */
export type BackgroundAuthItem = Message<"lvdr.v2.bgauth.BackgroundAuthItem"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * RFC3339
   *
   * @generated from field: string authorized_at = 2;
   */
  authorizedAt: string;

  /**
   * past the soft max-age → needs re-authorize
   *
   * @generated from field: bool expired = 3;
   */
  expired: boolean;
};

/**
 * Describes the message lvdr.v2.bgauth.BackgroundAuthItem.
 * Use `create(BackgroundAuthItemSchema)` to create a new message.
 */
export const BackgroundAuthItemSchema: GenMessage<BackgroundAuthItem> = /*@__PURE__*/
  messageDesc(file_bgauth_bgauth, 4);

/**
 * BackgroundAuthResponse is the shared response for authorize/revoke/set/list —
 * the server always echoes the full current state so the client never guesses.
 *
 * @generated from message lvdr.v2.bgauth.BackgroundAuthResponse
 */
export type BackgroundAuthResponse = Message<"lvdr.v2.bgauth.BackgroundAuthResponse"> & {
  /**
   * gate 1
   *
   * @generated from field: bool account_allowed = 1;
   */
  accountAllowed: boolean;

  /**
   * @generated from field: repeated lvdr.v2.bgauth.BackgroundAuthItem items = 2;
   */
  items: BackgroundAuthItem[];
};

/**
 * Describes the message lvdr.v2.bgauth.BackgroundAuthResponse.
 * Use `create(BackgroundAuthResponseSchema)` to create a new message.
 */
export const BackgroundAuthResponseSchema: GenMessage<BackgroundAuthResponse> = /*@__PURE__*/
  messageDesc(file_bgauth_bgauth, 5);

